import { useSnackbar } from 'notistack';
import { useContext, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  fetchRatesPackages,
  getPickupTimezone,
  getPickupValidate,
  validatePromoCode,
} from '../../../api/shipmentForms';
import { AbilityContext } from '../../../context/AbilityContext';
import { useShipForm } from '../../../context/shipForms';
import { BCPlanningLinesInitialValue } from '../../../initial-values';
import { RootState } from '../../../redux/rootReducer';
import { AddressDto } from '../../../types';
import { calculateInsuranceCost } from '../../../utils/helper';
import SearchField from '../../global-components/searchField';
import ShipmentATALegsTable from '../../global-components/shipment-legs-tables/shipmentATALegsTable';
import InsuranceModal from './insuranceModal';
import PickupAndDeliveryModals from './pickupAndDeliveryModals';
import RatesTable from "./ratesTable";
interface Props {
  setShowRatesForm: any;
  setShowPickup: any;
  setShowSummary: any;
  setCurrentShipmentStatus: any;
}
export const promo_formatter = new Intl.NumberFormat('en-CA', {
  style: 'decimal',
  currency: 'CAD',
  minimumFractionDigits: 2,
});
function RatesForm({
  setShowRatesForm,
  setShowPickup,
  setShowSummary,
  setCurrentShipmentStatus,
}: Props) {
  const {
    getDestinationFormData,
    getOriginFormData,
    getRatesApiDataContext,
    getRatesApiPayloadContext,
    setPickupValidateDataContext,
    setPickupTimezoneDataContext,
    setSelectedRateContext,
    setFinalRateContext,
    getFinalRateContext,
    getSelectedRateContext,
    setRatesApiDataContext,
    setSelectedPlanningLaneContext,
    setSelectedServiceContext,
    setSelectedATALegsInfo,
    getSelectedATALegsInfo,
  } = useShipForm();
  const { enqueueSnackbar } = useSnackbar();
  const hasEffectRun = useRef(false);
  const destinationFormContextData: AddressDto = getDestinationFormData();
  const originFormContextData: AddressDto = getOriginFormData();
  const ratesApiPayloadContext: any = getRatesApiPayloadContext();
  const ratesApiDataContext: any = getRatesApiDataContext();
  const selectedRateContext: any = getSelectedRateContext();
  const finalRateContext: any = getFinalRateContext();
  const selectedATALegsInfoContext: any = getSelectedATALegsInfo();

  const navigate = useNavigate();
  const [selectedRate, setSelectedRate] = useState<any>(
    selectedRateContext ? selectedRateContext : []
  );
  const ability = useContext(AbilityContext);
  const userData = useSelector(
    (state: RootState) => state.mainAppData.userData
  );
  const isVendor = userData?.is_vendor;
  const orderLeg = ['P', 'A1', 'T', 'A2', 'D'];
  const [isPriceHidden, setIsPriceHidden] = useState<any>(
    !ability?.can('read', 'View Price')
  );
  const [promoCode, setPromoCode] = useState('');
  const [insuranceField, setInsuranceField] = useState(
    finalRateContext ? finalRateContext?.insuranceField : ''
  );
  const [insurance, setInsurance] = useState<any>(
    finalRateContext ? finalRateContext?.insurance : ''
  );
  const [discount, setDiscount] = useState(
    finalRateContext ? finalRateContext?.savings : '0.00'
  );
  const [loading, setLoading] = useState(false);
  const [businessPlanningLanesStart, setBusinessPlanningLanesStart] =
    useState<any>(BCPlanningLinesInitialValue);
  const [searchText, setSearchText] = useState('');
  const [showInsuranceModal, setShowInsuranceModal] = useState(false);
  const [estCost, setEstCost] = useState<any>({});
  const [ratesData, setRatesData] = useState<any>(
    ratesApiDataContext ? ratesApiDataContext : null
  );
  const [showPickupDeliveryScreen, setShowPickupDeliveryScreen] =
    useState(false);

  const [tableLoading, setTableLoading] = useState(false);
  const [selectedLegsInfo, setSelectedLegsInfo] = useState<any>(
    selectedATALegsInfoContext ? selectedATALegsInfoContext : []
  );
  const location = useLocation();
  function backRoute() {
    setShowRatesForm(false);
    setCurrentShipmentStatus('packages');
  }
  function nextRates() {
    let insurancePrice = insurance ? parseFloat(insurance) : 0.0;
    let total = insurancePrice
      ? insurancePrice + estCost?.total
      : estCost?.total;
    total = total - parseFloat(discount);
    setLoading(true);
    let finalRates = {
      savings: discount ? discount : '0.00',
      subTotal: estCost?.subTotal,
      tax: estCost?.tax,
      insurance: insurance,
      insuranceField: insuranceField,
      total: total,
    };
    let timezonePayload = {
      city: originFormContextData?.city,
      province: originFormContextData?.province,
      country: originFormContextData?.country,
    };

    if (
      selectedRate?.main?.routing[0]?.carrier_id &&
      (selectedRate?.pickup !== undefined ||
        (selectedRate?.main?.mode_code !== 'ATA' &&
          selectedRate?.main?.mode_code !== 'MMA'))
    ) {
      getPickupTimezone(timezonePayload)
        .then((response) => {
          if (response?.data?.is_error === false) {
            setPickupTimezoneDataContext(response?.data?.content);
          }
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
        });
      getPickupValidate(selectedRate?.main?.routing[0]?.carrier_id)
        .then((response) => {
          setLoading(false);
          if (response?.data?.is_error === false) {
            handleServiceAndPlanningLanesContext(); //write the logic of service and planning lanes here
            setSelectedATALegsInfo(selectedLegsInfo);
            setPickupValidateDataContext(response?.data?.content);
            setFinalRateContext(finalRates);
            setSelectedRateContext(selectedRate);
            setTimeout(() => {
              window?.scrollTo(0, 0);
              setShowPickup(true);
              setCurrentShipmentStatus('pickup');
            }, 300);
          }
        })
        .catch((e) => {
          setLoading(false);
        });
    } else if (selectedRate?.main === undefined) {
      enqueueSnackbar('Please select a rate.', { variant: 'error' });
      setLoading(false);
    } else {
      handleServiceAndPlanningLanesContext(); //write the logic of service and planning lanes here
      setFinalRateContext(finalRates);
      setSelectedATALegsInfo(selectedLegsInfo);
      setSelectedRateContext(selectedRate);

      setTimeout(() => {
        window?.scrollTo(0, 0);
        setShowSummary(true);
        setCurrentShipmentStatus('summary');
      }, 300);
    }
  }
  function applyPromo() {
    let subTotal =
      parseFloat(selectedRate?.main?.total) -
      parseFloat(selectedRate?.main?.tax);
    if (promoCode !== '') {
      setLoading(true);
      let payload = {
        promo_code: promoCode,
        pre_tax_cost: promo_formatter.format(subTotal).replace(/,/g, ''),
      };
      validatePromoCode(payload)
        ?.then((response) => {
          if (response?.data?.is_error === false) {
            setLoading(false);
            setDiscount(response?.data?.content['discount']);
          }
        })
        .catch((e) => {
          setLoading(false);
        });
    } else {
      enqueueSnackbar('Please select rate and add promo code.', {
        variant: 'error',
      });
    }
  }
  function shipFromQuote() {
    if (
      selectedRate &&
      selectedRate?.main &&
      selectedRate?.main?.carrier_id !== ''
    ) {
      let rateId = ratesApiDataContext?.content?.rate_id;
      navigate(`/app/ship-now?rate_id=${rateId}`, {
        state: { quoteData: ratesApiPayloadContext },
      });
    } else {
      enqueueSnackbar('Please select any rate.', { variant: 'error' });
    }
  }
  function saveQuoteFunc() {
    if (
      selectedRate &&
      selectedRate?.main &&
      selectedRate?.main?.carrier_id !== ''
    ) {
      let rateId = ratesApiDataContext?.content?.rate_id;
      let transferRates = selectedRate?.main?.transfer_rates;
      let allRates = ratesApiDataContext;
      if (allRates?.content && transferRates) {
        allRates.content.transfer_rates = transferRates;
      }

      navigate(`/app/quotes/save-quote?rate_id=${rateId}`, {
        state: {
          quoteData: {
            all_rates: allRates,
            details: ratesApiPayloadContext,
            selected_rates: selectedRate,
          },
        },
      });
      window?.scrollTo(0, 0);
    } else {
      enqueueSnackbar('Please select any rate.', { variant: 'error' });
    }
  }
  function handleServiceAndPlanningLanesContext() {
    const mappedArray =
      selectedLegsInfo &&
      selectedLegsInfo.map((item: any) => ({
        carrier_id: item?.routing?.carrier_id,
        service_code: item?.routing?.service_code,
        origin_code: item?.routing?.origin_code,
        destination_code: item?.routing?.destination_code,
      }));

    let serviceInfo: any = {
      mode_code: selectedRate?.main?.mode_code,
      routing: mappedArray,
    };

    const mappedPlanningArray =
      selectedLegsInfo &&
      selectedLegsInfo.map((item: any, index: number) => ({
        leg: `L${index+1}`,
        carrier_id: item?.routing?.carrier_id,
        line_type: '3',
        item: 'TRANSPORTATION',
        markup: '',
        branch_code: userData?.bc_branch_code
          ? Number(userData?.bc_branch_code)
          : 130,
        cost_centre: userData?.bc_cost_centre
          ? userData?.bc_cost_centre
          : '210',
        location_code: userData?.bc_location_code
          ? userData?.bc_location_code
          : 'YEGFF',
      }));
    setSelectedPlanningLaneContext([
      ...businessPlanningLanesStart,
      ...mappedPlanningArray,
    ]);
    setSelectedServiceContext(serviceInfo);
  }
  useEffect(() => {
    if (
      ratesApiPayloadContext &&
      !hasEffectRun.current &&
      !selectedRate?.main
    ) {
      setTableLoading(true);
      fetchRatesPackages(ratesApiPayloadContext)
        .then((response) => {
          if (!response?.data?.is_error) {
            setTableLoading(false);
            setRatesData(response?.data);
            setRatesApiDataContext(response?.data);
          }
        })
        .catch((e) => {
          setTableLoading(false);
        });
      hasEffectRun.current = true;
    }
  }, [ratesApiPayloadContext]);

  function handleDeleteLeg(leg: string) {
    if (leg === 'D') {
      const updatedRate = { ...selectedRate, delivery: undefined };
      setSelectedRate(updatedRate);
    }

    if (leg === 'P') {
      const updatedRate = { ...selectedRate, pickup: undefined };
      setSelectedRate(updatedRate);
    }

    setSelectedLegsInfo((prevLegs: any) => {
      let tempLegs = prevLegs.filter((item: any) => item.leg !== leg);
      return tempLegs;
    });
  }

  useEffect(() => {
    const updatedLines = BCPlanningLinesInitialValue.map((line) => ({
      ...line,
      branch_code: userData?.bc_branch_code
        ? Number(userData.bc_branch_code)
        : 130,
      cost_centre: userData?.bc_cost_centre || line.cost_centre,
      location_code: userData?.bc_location_code || line.location_code,
    }));
    setBusinessPlanningLanesStart(updatedLines);
  }, []);

  useEffect(() => {
    if (selectedLegsInfo && selectedLegsInfo.length > 0) {
      let tax = 0;
      let subtotal = 0;
      let total = 0;

      selectedLegsInfo.forEach((legInfo: any) => {
        const ratesInfo = legInfo?.ratesInfo;

        if (ratesInfo && legInfo.leg !== 'A2') {
          const taxAmount = parseFloat(ratesInfo.tax);
          const totalAmount = parseFloat(ratesInfo.total);

          if (!isNaN(taxAmount) && !isNaN(totalAmount)) {
            tax += taxAmount;
            subtotal += totalAmount - taxAmount;
            total += totalAmount;
          }
        }
      });
      tax = parseFloat(tax.toFixed(2));
      subtotal = parseFloat(subtotal.toFixed(2));
      total = parseFloat(total.toFixed(2));

      setEstCost({
        ...estCost,
        tax: tax,
        total: total,
        subTotal: subtotal,
      });
    }
  }, [selectedLegsInfo]);

  return (
    <div>
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}

      <div className='row mt-5'>
        <div className='col-sm-12 col-md-12'>
          <div className=''>
            <div className=''>
              {!showPickupDeliveryScreen && (
                <div className='row mb-4'>
                  <div className='col-12 d-flex justify-content-between align-items-center'>
                    <h5 className='rates__title'>
                      Estimated Rates for
                      <span id='origin-city'>
                        {' '}
                        {`${originFormContextData?.city} -> `}
                      </span>
                      <span id='destination-city'>
                        {destinationFormContextData?.city}
                      </span>
                    </h5>
                    <div className='position-relative'>
                      <SearchField
                        id={'exampleFormControlInput1'}
                        placeHolder={'Search'}
                        className={'form-control ubbe-input w-100 pr-4-5'}
                        handleSearchField={setSearchText}
                        setSearchQuery={setSearchText}
                        searchText={searchText}
                      />
                    </div>
                  </div>
                </div>
              )}

              {showPickupDeliveryScreen ? (
                <PickupAndDeliveryModals
                  setShowModal={setShowPickupDeliveryScreen}
                  selectedRate={selectedRate}
                  setSelectedRate={setSelectedRate}
                  rates={ratesApiDataContext?.content}
                  isPriceHidden={isPriceHidden}
                  selectedLegsInfo={selectedLegsInfo}
                  setSelectedLegsInfo={setSelectedLegsInfo}
                  orderLeg={orderLeg}
                />
              ) : (
                <RatesTable
                  tableData={
                    ratesApiDataContext ? ratesApiDataContext : ratesData
                  }
                  setShowPickupDeliveryScreen={setShowPickupDeliveryScreen}
                  setSelectedRate={setSelectedRate}
                  selectedRate={selectedRate}
                  searchText={searchText}
                  tableLoading={tableLoading}
                  isPriceHidden={isPriceHidden}
                  setSelectedLegsInfo={setSelectedLegsInfo}
                  selectedLegsInfo={selectedLegsInfo}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {!showPickupDeliveryScreen && (
        <>
          <div className='row mt-5'>
            <div className='col-sm-12 col-md-6'>
              <div className='d-flex flex-column'></div>
              <div className='d-flex align-items-center'>
                <h5 className='lex-main-18-400 '>
                  Would you like to take insurance?
                  <span
                    className='ms-1 me-1'
                    onClick={() => setShowInsuranceModal(true)}
                  >
                    <svg
                      width='15'
                      height='15'
                      className='h-auto pb-1'
                      viewBox='0 0 15 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.5 15C3.35775 15 0 11.6423 0 7.5C0 3.35775 3.35775 0 7.5 0C11.6423 0 15 3.35775 15 7.5C15 11.6423 11.6423 15 7.5 15ZM6.978 12.3495C7.4505 12.3495 7.977 12.1335 8.625 11.256L9.30825 10.341C9.32822 10.3143 9.34265 10.2838 9.35068 10.2514C9.35871 10.219 9.36019 10.1853 9.35501 10.1523C9.34984 10.1193 9.33813 10.0877 9.32057 10.0593C9.30301 10.0309 9.27995 10.0064 9.25275 9.987C9.19522 9.94638 9.12468 9.92849 9.05474 9.9368C8.9848 9.94511 8.92041 9.97903 8.874 10.032L7.76775 11.2913C7.7423 11.3202 7.70827 11.3402 7.67063 11.3485C7.63299 11.3567 7.5937 11.3527 7.5585 11.337C7.52433 11.322 7.49656 11.2954 7.48009 11.2619C7.46362 11.2284 7.45952 11.1902 7.4685 11.154L8.862 5.5695C8.8774 5.50864 8.87724 5.44488 8.86154 5.38409C8.84584 5.3233 8.8151 5.26744 8.77215 5.22165C8.72919 5.17586 8.67541 5.14161 8.61575 5.12206C8.55609 5.1025 8.49247 5.09827 8.43075 5.10975L5.91825 5.5695C5.86885 5.57857 5.82309 5.60162 5.7864 5.63592C5.74971 5.67022 5.72363 5.71432 5.71125 5.763L5.64675 6.0135C5.63965 6.04124 5.63899 6.07024 5.64484 6.09827C5.65068 6.1263 5.66287 6.15262 5.68047 6.17521C5.69806 6.1978 5.7206 6.21607 5.74634 6.2286C5.77209 6.24113 5.80037 6.24759 5.829 6.2475H7.1265L6.0195 10.689C5.979 10.8645 5.9115 11.1615 5.9115 11.3775C5.9115 11.877 6.2085 12.3495 6.978 12.3495ZM8.3505 4.4475C8.877 4.4475 9.282 4.137 9.39 3.6645C9.417 3.5565 9.4305 3.435 9.4305 3.354C9.4305 2.976 9.1335 2.625 8.58 2.625C8.0535 2.625 7.6485 2.9355 7.5405 3.408C7.51544 3.50966 7.50185 3.61381 7.5 3.7185C7.5 4.0965 7.797 4.4475 8.3505 4.4475Z'
                        fill='#251163'
                      />
                    </svg>
                  </span>
                  <span className='lex-14-300 color-black '>(Optional)</span>
                </h5>
              </div>
              <div className='d-flex w-100 '>
                <div className='d-flex w-100'>
                  <input
                    className='form-control ubbe-input w-100'
                    id='insurance_cost'
                    type='text'
                    maxLength={8}
                    autoComplete='new-password'
                    placeholder='Please enter the estimated value of your package'
                    value={insuranceField}
                    onChange={(e) => {
                      setInsuranceField(e.target.value.replace(/[^0-9]/g, ''));
                      let insurance = calculateInsuranceCost(
                        e.target.value.replace(/[^0-9]/g, '')
                      );
                      setInsurance(insurance);
                    }}
                  />{' '}
                  <span
                    className='clear-icon cursor_pointer'
                    onClick={() => {
                      // "remove_promo(this)"
                      setInsuranceField('');
                      setInsurance('');
                    }}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='20'
                      height='17'
                      viewBox='0 0 20 17'
                      fill='none'
                    >
                      <path
                        d='M15.0019 0H8.28439C6.87492 0 5.53542 0.607879 4.58578 1.6897L1.0571 5.68727C-0.352368 7.28424 -0.352368 9.71576 1.0571 11.3127L4.58578 15.3103C5.53542 16.3818 6.87492 17 8.28439 17H15.0019C17.7608 17 20 14.6921 20 11.8485V5.15152C20 2.30788 17.7608 0 15.0019 0ZM14.5321 10.4988C14.8219 10.7976 14.8219 11.2921 14.5321 11.5909C14.3821 11.7455 14.1922 11.8176 14.0022 11.8176C13.8123 11.8176 13.6224 11.7455 13.4724 11.5909L11.5332 9.59212L9.5939 11.5909C9.44396 11.7455 9.25403 11.8176 9.0641 11.8176C8.87417 11.8176 8.68424 11.7455 8.5343 11.5909C8.24441 11.2921 8.24441 10.7976 8.5343 10.4988L10.4736 8.5L8.5343 6.50121C8.24441 6.20242 8.24441 5.70788 8.5343 5.40909C8.82419 5.1103 9.30401 5.1103 9.5939 5.40909L11.5332 7.40788L13.4724 5.40909C13.7623 5.1103 14.2422 5.1103 14.5321 5.40909C14.8219 5.70788 14.8219 6.20242 14.5321 6.50121L12.5928 8.5L14.5321 10.4988Z'
                        fill='#292D32'
                        fill-opacity='0.5'
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
            <div className='col-sm-12 col-md-6'>
              <div className=''>
                <div className=' '>
                  <h5 className='lex-main-18-400 mb_0'>
                    Have a promo code? <span id='promo_status'></span>
                  </h5>

                  <div className='row mt-2 d-flex'>
                    <div className='d-flex'>
                      <input
                        className='form-control ubbe-input'
                        id='promo_code'
                        type='text'
                        placeholder='Enter promo code'
                        maxLength={30}
                        autoComplete='new-password'
                        value={promoCode}
                        onChange={(e) => {
                          setPromoCode(e.target.value);
                        }}
                      />
                      <span
                        className='clear-icon cursor_pointer'
                        onClick={() => {
                          // "remove_promo(this)"
                          setDiscount('0.00');
                          setPromoCode('');
                        }}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='20'
                          height='17'
                          viewBox='0 0 20 17'
                          fill='none'
                        >
                          <path
                            d='M15.0019 0H8.28439C6.87492 0 5.53542 0.607879 4.58578 1.6897L1.0571 5.68727C-0.352368 7.28424 -0.352368 9.71576 1.0571 11.3127L4.58578 15.3103C5.53542 16.3818 6.87492 17 8.28439 17H15.0019C17.7608 17 20 14.6921 20 11.8485V5.15152C20 2.30788 17.7608 0 15.0019 0ZM14.5321 10.4988C14.8219 10.7976 14.8219 11.2921 14.5321 11.5909C14.3821 11.7455 14.1922 11.8176 14.0022 11.8176C13.8123 11.8176 13.6224 11.7455 13.4724 11.5909L11.5332 9.59212L9.5939 11.5909C9.44396 11.7455 9.25403 11.8176 9.0641 11.8176C8.87417 11.8176 8.68424 11.7455 8.5343 11.5909C8.24441 11.2921 8.24441 10.7976 8.5343 10.4988L10.4736 8.5L8.5343 6.50121C8.24441 6.20242 8.24441 5.70788 8.5343 5.40909C8.82419 5.1103 9.30401 5.1103 9.5939 5.40909L11.5332 7.40788L13.4724 5.40909C13.7623 5.1103 14.2422 5.1103 14.5321 5.40909C14.8219 5.70788 14.8219 6.20242 14.5321 6.50121L12.5928 8.5L14.5321 10.4988Z'
                            fill='#292D32'
                            fill-opacity='0.5'
                          />
                        </svg>
                      </span>
                      <button
                        type='button'
                        className='btn btn-ubbe-new-blue promo-code-btn'
                        onClick={() => {
                          applyPromo();
                        }}
                      >
                        Apply
                      </button>
                    </div>
                    <div className=''></div>
                    {/* <div className='col-6 col-md-6 col-xl-3 text-end mt-2 mt-lg-0'>
                  <button
                    type='button'
                    className='btn btn-ubbe w-100'
                    onClick={() => {
                      // "remove_promo(this)"
                      setDiscount('0.00');
                      setPromoCode('');
                    }}
                  >
                    Remove
                  </button>
                </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className=''>
            <ShipmentATALegsTable
              selectedRates={selectedRate}
              selectedLegsInfo={selectedLegsInfo}
              showInsuranceAndDiscount={true}
              discountAmount={discount ? discount : 0.0}
              insuranceAmount={insurance ? insurance : '0.00'}
              handleDeleteLeg={handleDeleteLeg}
              isPriceHidden={isPriceHidden}
            />
          </div>
          <div className='mt-5 d-flex justify-content-between align-items-center'>
            <div className=''>
              <p
                className='btn btn-ubbe-new-back d-flex gap-2'
                onClick={() => {
                  backRoute();
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='15'
                  height='8'
                  viewBox='0 0 15 8'
                  fill='none'
                >
                  <path
                    d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                    fill='black'
                  />
                </svg>
                Back
              </p>
            </div>

            <div className='d-flex'>
              {!isVendor && location?.pathname !== '/app/add-leg' && (
                <p
                  className='btn-ubbe-ghost'
                  onClick={() => {
                    saveQuoteFunc();
                  }}
                >
                  Save Quote
                </p>
              )}
              <p
                className='btn btn-ubbe-new-blue ms-2'
                onClick={() => {
                  location?.pathname === '/app/quick-quote'
                    ? shipFromQuote()
                    : nextRates();
                }}
              >
                {location?.pathname === '/app/quick-quote'
                  ? 'Ship'
                  : 'Continue'}
              </p>
            </div>
          </div>
        </>
      )}
      {showInsuranceModal && (
        <InsuranceModal setShowInsuranceModal={setShowInsuranceModal} />
      )}
    </div>
  );
}

export default RatesForm;
